export default __webpack_public_path__ + "static/media/bg-step5.4ab8bf40.jpg";